define('TescoMobile_Checkout/js/model/messageList',['./messages'], function (Messages) {
  'use strict';

  return new Messages();
});

